<template>
  <button class="button">
    <slot></slot>
  </button>
</template>
<style scoped>
.button {
  color: #fff;
  background: #43676b; /* 「青鈍」 */
  padding: 1rem 0.5rem;
  width: 20rem;
  font-size: 3rem;
  font-family: "Sawarabi Mincho", sans-serif;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 64px;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25),
    0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>
